import { render, staticRenderFns } from "./BatchDownload.vue?vue&type=template&id=e8e690ca"
import script from "./BatchDownload.vue?vue&type=script&lang=js"
export * from "./BatchDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports